import { User } from "./user"

export class RelatedUser {
    constructor(value?: User) {
        if (value) {
            this.user_Id = value.id;
            this.name = value.displayName;
            this.mobilePhone = value.mobilePhone;
            this.mail = value.mail;
            this.workPhone = value.workPhone;
        }
    }
    user_Id: string;
    name: string;
    mail: string;
    workPhone: string;
    mobilePhone: string;
}